import { combineReducers } from 'redux';

import shipments from 'state/direct-order/shipments';
import extras from 'state/direct-order/extras';
import repeatedFrom from 'state/direct-order/repeated-from';
import quote from 'state/direct-order/quote';
import insurance from 'state/direct-order/insurance';

import ui from 'state/direct-order/ui';

const data = combineReducers({
  shipments,
  extras,
  insurance,
  repeatedFrom,
});

const reducer = combineReducers({
  data,
  ui,
  quote,
});

export default reducer;
